import { Assets } from 'pixi.js'

import auto_normal from '../../../asset/images/auto/auto_on_normal.png'
import auto_hover from '../../../asset/images/auto/auto_on_hover.png'
import auto_click from '../../../asset/images/auto/auto_on_click.png'
import auto_disable from '../../../asset/images/auto/auto_on_unable.png'
import auto_off_bg from '../../../asset/images/auto/autoTimes.png'
import auto_off_normal from '../../../asset/images/auto/auto_off_normal.png'
import auto_off_hover from '../../../asset/images/auto/auto_off_hover.png'
import auto_off_click from '../../../asset/images/auto/auto_off_click.png'
import auto_off_disabled from '../../../asset/images/auto/auto_on_unable_x.png'
import auto_icon_infinity from '../../../asset/images/auto/icon_unlimited_open.png'
import auto_icon_infinity_close from '../../../asset/images/auto/icon_unlimited_close.png'

import auto_confirm_btn_normal from '../../../asset/images/auto/image_menuBtnB_normal.png'
import auto_confirm_btn_hover from '../../../asset/images/auto/image_menuBtnB_hover.png'
import auton_confirm_btn_pressed from '../../../asset/images/auto/image_menuBtnB_pressed.png'
import auton_confirm_btn_disable from '../../../asset/images/auto/image_menuBtnB_disable.png'

import auto_option_normal_v2 from '../../../asset/images/auto/btn_autoRoubd_unable.png'
import auto_option_hover_v2 from '../../../asset/images/auto/btn_autoRoubd_hover.png'
import auto_option_click_v2 from '../../../asset/images/auto/btn_autoRoubd_click.png'
import auto_option_unable_v2 from '../../../asset/images/auto/btn_autoRoubd_normal.png'

import close_btn_normal from '../../../asset/images/auto/close_normal.png'
import close_btn_hover from '../../../asset/images/auto/close_hover.png'
import close_btn_click from '../../../asset/images/auto/close_click.png'

import loadingImage from '../../../asset/images/Loading.png'

const loadAutoAssets = async () => {
  await Assets.load([
    { alias: 'auto_normal_v2', src: auto_normal, loadParser: 'loadTextures' },
    { alias: 'auto_hover_v2', src: auto_hover, loadParser: 'loadTextures' },
    { alias: 'auto_click_v2', src: auto_click, loadParser: 'loadTextures' },
    { alias: 'auto_disable_v2', src: auto_disable, loadParser: 'loadTextures' },
    { alias: 'auto_bg_v2', src: auto_off_bg, loadParser: 'loadTextures' },
    { alias: 'auto_off_normal_v2', src: auto_off_normal, loadParser: 'loadTextures' },
    { alias: 'auto_off_hover_v2', src: auto_off_hover, loadParser: 'loadTextures' },
    { alias: 'auto_off_click_v2', src: auto_off_click, loadParser: 'loadTextures' },
    { alias: 'auto_off_disabled_v2', src: auto_off_disabled, loadParser: 'loadTextures' },
    { alias: 'auto_icon_infinity_v2', src: auto_icon_infinity, loadParser: 'loadTextures' },
    { alias: 'auto_icon_infinity_close_v2', src: auto_icon_infinity_close, loadParser: 'loadTextures' },
    { alias: 'auto_confirm_btn_normal', src: auto_confirm_btn_normal, loadParser: 'loadTextures' },
    { alias: 'auto_confirm_btn_hover', src: auto_confirm_btn_hover, loadParser: 'loadTextures' },
    { alias: 'auton_confirm_btn_pressed', src: auton_confirm_btn_pressed, loadParser: 'loadTextures' },
    { alias: 'auton_confirm_btn_disable', src: auton_confirm_btn_disable, loadParser: 'loadTextures' },
    { alias: 'auto_option_normal_v2', src: auto_option_normal_v2, loadParser: 'loadTextures' },
    { alias: 'auto_option_hover_v2', src: auto_option_hover_v2, loadParser: 'loadTextures' },
    { alias: 'auto_option_click_v2', src: auto_option_click_v2, loadParser: 'loadTextures' },
    { alias: 'auto_option_unable_v2', src: auto_option_unable_v2, loadParser: 'loadTextures' },
  ])
}

const loadCloseAssets = async () => {
  await Assets.load([
    { alias: 'close_btn_normal', src: close_btn_normal, loadParser: 'loadTextures' },
    { alias: 'close_btn_hover', src: close_btn_hover, loadParser: 'loadTextures' },
    { alias: 'close_btn_click', src: close_btn_click, loadParser: 'loadTextures' },
  ])
}

export const loadLoadingImage = async () => {
  await Assets.load([
    { alias: 'Loading', src: loadingImage, loadParser: 'loadTextures' },
  ])
}

export const loadLibAssets = async () => {
  await Promise.all([
    loadAutoAssets(),
    loadCloseAssets(),
    loadLoadingImage(),
  ])
}
